import { lazy } from 'react';
import { csmKeys } from '../assets/text';
import { Navigate } from 'react-router-dom';

const DeviationsBrowser = lazy(() =>
  import('../containers/@DeviationsBrowser')
);
const DeviationsBrowser2 = lazy(() =>
  import('../containers/@DeviationsBrowser2')
);

const appRoutes = [
  {
    path: '/',
    name: 'Default',
    isExact: false,
    showInMenu: false,
    element: <Navigate to={'/browser2'} />,
    subRoutes: [],
    permission: csmKeys.PROTOCOLDEVIATIONSBROWSER
  },
  {
    path: '/browser', // /deviations
    name: 'Browser (v1)', // Deviations
    isExact: false,
    showInMenu: true,
    element: <DeviationsBrowser />,
    subRoutes: [],
    permission: csmKeys.PROTOCOLDEVIATIONSBROWSER
  },
  {
    path: '/browser2', // /deviations
    name: 'Browser (v2)', // Deviations
    isExact: false,
    showInMenu: true,
    element: <DeviationsBrowser2 />,
    subRoutes: [],
    permission: csmKeys.PROTOCOLDEVIATIONSBROWSER
  }
];
export default appRoutes;
